export default __webpack_public_path__ + "f181a16904ebf4a27ce95d009390865c.woff";